import React, { Component } from "react";
import PropTypes from "prop-types";
import classnames from "classnames";

import getPlaceholderImageUrl from "shared/util/getPlaceholderImageUrl";

import "./UserThumb.scss";

class UserThumb extends Component {
	static displayTypes = {
		Round: "round",
		Box: "box",
	};

	static propTypes = {
		thumbs: PropTypes.array,
		size: PropTypes.string,
		username: PropTypes.string.isRequired,
		shape: PropTypes.oneOf(Object.values(UserThumb.displayTypes)),
	};
	static defaultProps = {
		thumbs: null,
		size: "225x225",
		shape: UserThumb.displayTypes.Round,
	};

	state = {
		loadError: false,
	};

	onLoadError = () => {
		this.setState({
			loadError: true,
		});
	};

	getThumbnailImage = () => {
		const {
			thumbs,
			size = "225x225",
		} = this.props;
		const {
			loadError,
		} = this.state;

		// Something failed while loading, fallback!
		if (loadError) {
			return getPlaceholderImageUrl();
		}

		// Try to get the user thumbnail.
		const userThumb = thumbs && thumbs[0]
			? thumbs[0][size]
			: null;

		// Return thumbnail or fallback to placeholder.
		return userThumb || getPlaceholderImageUrl();
	};

	render() {
		const {
			username,
			shape,
		} = this.props;

		// Get the thumbnail image for this user.
		const thumb = this.getThumbnailImage();

		const containerClass = classnames("userthumb", {
			[`userthumb--${process.env.PLATFORM}`]: true,
			[`userthumb--${shape}`]: true,
		});

		return (
			<span className={containerClass}>
				<img
					className="userthumb-img"
					src={thumb}
					alt={username}
					onError={this.onLoadError}
				/>
			</span>
		);
	}
}

export default UserThumb;



// WEBPACK FOOTER //
// ./src/shared/components/UserThumb.jsx